import { sha256 } from '../crypto/sha256';
import { extractTbs, tbsFields } from './tbs';

/** DER SubjectPublicKeyInfo of a certificate. */
export function spkiOf(certDer: Uint8Array): Uint8Array {
  return tbsFields(extractTbs(certDer)).spki;
}

/** RFC 6962 §3.2 issuer_key_hash: SHA-256 over the issuer's SubjectPublicKeyInfo. */
export function issuerKeyHash(issuerCertDer: Uint8Array): Promise<Uint8Array> {
  return sha256(spkiOf(issuerCertDer));
}
